/*!

 =========================================================
 * Vue Now UI Kit - v1.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/now-ui-kit
 * Copyright 2019 Creative Tim (http://www.creative-tim.com)

 * Designed by www.invisionapp.com Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
import Vue from "vue";
import axios from "axios";

import App from "./App.vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faFontAwesome } from "@fortawesome/free-brands-svg-icons";

import {
  faVideo,
  faHeart,
  faQuestion,
  faEdit,
  faBed,
  faGifts,
  faGift,
  faSnowflake,
  faCommentAlt,
  faCalendarAlt,
  faClock,
  faMapMarkerAlt,
  faChurch,
  faUtensils,
  faCar,
  faTrain,
  faBusAlt,
  faPlaneDeparture,
} from "@fortawesome/free-solid-svg-icons";
// You can change this import to `import router from './starterRouter'` to quickly start development from a blank layout.
import router from "./starterRouter";
import NowUiKit from "./plugins/now-ui-kit";
import i18n from "@/plugins/i18n";
import FlagIcon from "vue-flag-icon";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

/*import { Icon }  from 'leaflet'
 import 'leaflet/dist/leaflet.css'
import L from 'leaflet';
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
}); */

library.add(
  faVideo,
  faHeart,
  faQuestion,
  faEdit,
  faBed,
  faGifts,
  faGift,
  faSnowflake,
  faCommentAlt,
  faCalendarAlt,
  faClock,
  faMapMarkerAlt,
  faChurch,
  faUtensils,
  faCar,
  faTrain,
  faBusAlt,
  faPlaneDeparture
);
library.add(faFontAwesome);

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.config.productionTip = false;

Vue.use(NowUiKit);
Vue.use(FlagIcon);

Vue.prototype.$axios = axios;

new Vue({
  router,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
